<template>
  <div class="personInfo">
    <info-form isEdit :info="info" @submit-form="submitForm"> </info-form>
  </div>
</template>

<script>
import { setUserInfo } from "@/api/user.js";
import { mapState } from "vuex";
import { Toast } from "vant";
export default {
  name: "PersonInfo",
  data() {
    return { info: {} };
  },
  methods: {
    async submitForm(form) {
      const { code,msg } = await setUserInfo(form);
      if (code === 0) {
        this.$toast({
          message: "保存成功",
          icon: require("@/assets/images/success.png")
        });
        this.$router.go("-1");
      }else{
        Toast(msg);
      }
    }
  },
  computed: {
    ...mapState("user", ["openId"])
  }
};
</script>

<style lang="scss" scoped>
.personInfo {
}
</style>
